import { render, staticRenderFns } from "./record_loader.vue?vue&type=template&id=e9b40c62&scoped=true"
import script from "./record_loader.vue?vue&type=script&lang=js"
export * from "./record_loader.vue?vue&type=script&lang=js"
import style0 from "./record_loader.vue?vue&type=style&index=0&id=e9b40c62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b40c62",
  null
  
)

export default component.exports